import { http } from "api/http";

const analyzeAttachmentFromCloud = (data: {
  notice:any;
}) => {
  return http.post("/ai/analyze-cloud", data);
};

export {
  analyzeAttachmentFromCloud,
};
